<template>
  <b-row>
    <div class="col-xl-4 mb-4">
      <h6 class="heading-small text-muted mb-4">Your Picture</h6>

<!--      <div v-if="profileImageCropped" class="text-center my-5">-->
<!--        <a href="#!" class="avatar rounded-circle" >-->
<!--          <img alt="Image placeholder" :src="profileImageCropped">-->
<!--        </a>-->
<!--        <a href="#!" class="avatar avatar-lg rounded-circle">-->
<!--          <img alt="Image placeholder" :src="profileImageCropped">-->
<!--        </a>-->
<!--        <a href="#!" class="avatar avatar-xl rounded-circle">-->
<!--          <img alt="Image placeholder" :src="profileImageCropped">-->
<!--        </a>-->
<!--      </div>-->

      <div class="text-center">
        <b-avatar class="avatar avatar-xl rounded-circle" :src="userPhoto"></b-avatar>
      </div>

      <hr>

      <b-form-file @input="profilePicEvent"></b-form-file>
      <onboard-cropper v-if="profileImageSrc !== undefined" :key="profileImageSrc" :img-src="profileImageSrc" :show-on-mount="true" @crop-finish="cropFinish"></onboard-cropper>

    </div>

    <div class="col-xl-8">
      <form>
        <h6 class="heading-small text-muted mb-4">Your Info</h6>
        <ValidationObserver ref="validationObserver">
          <div class="pl-lg-4">
            <div class="row">
              <div class="col-lg-12">
                <base-input type="text" label="Nickname" placeholder="Nickname" v-model="nickName"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <ValidationProvider name="fist name" rules="required" v-slot="{ errors }">
                  <base-input type="text" label="First Name" placeholder="First Name" v-model="firstName"></base-input>
                  <b-form-invalid-feedback :state="errors.length === 0"> {{errors[0]}} </b-form-invalid-feedback>
                </ValidationProvider>
              </div>
              <div class="col-lg-6">
                <ValidationProvider name="last name" rules="required" v-slot="{ errors }">
                  <base-input type="text" label="Last Name" placeholder="Last Name" v-model="lastName"></base-input>
                  <b-form-invalid-feedback :state="errors.length === 0"> {{errors[0]}} </b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <base-input type="tel" label="Phone Number" placeholder="Phone Number" v-model="phone"></base-input>
<!--                TODO: add phone validation - no built in rule to vee-validate -->
<!--                <ValidationProvider name="phone number" rules="required" v-slot="{ errors }">-->
<!--                  <b-form-invalid-feedback :state="errors.length === 0"> {{errors[0]}} </b-form-invalid-feedback>-->
<!--                </ValidationProvider>-->
              </div>
              <div class="col-lg-6">
                <base-input type="email" label="Email address" placeholder="Email" v-model="email" disabled></base-input>
              </div>
            </div>
          </div>
        </ValidationObserver>
      </form>
    </div>
    <div class="card-footer">
      <b-form-invalid-feedback :state="!errorMessage" class="text-center">
          {{errorMessage}}
      </b-form-invalid-feedback>
    </div>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
import {
  UserUpdateDetailedInfoRequest,
} from '#/protobuf/service_user_pb';
import OnboardCropper from '#/ui/Components/Onboard/OnboardCropper.vue';
import { UserUpdateInfo } from '#/protobuf/user_pb';
// import 'cropperjs/dist/cropper.css';

export default {
  components: {
    OnboardCropper,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      nickName: '',
      firstName: '',
      lastName: '',
      phone: '',
      email: '',

      errorMessage: undefined,

      profileImageSrc: undefined,
      profileImageCropped: undefined, // default image til cropped
    };
  },
  created() {
    this.firstName = this.$store.getters['user/userFirstName'];
    this.lastName = this.$store.getters['user/userLastName'];
    this.nickName = this.$store.getters['user/userNickname'];
    this.phone = this.$store.getters['user/userPhoneNumber'];
    this.email = this.$store.getters['user/userEmail'];
  },
  computed: {
    ...mapGetters('user', [
      'userPhoto',
    ]),
  },
  methods: {
    ...mapActions('user', {
      requestProfilePicUpload: 'requestProfilePicUpload',
      updateDetails: 'updateDetails',
    }),
    buildUpdateRequest() {
      const request = new UserUpdateDetailedInfoRequest();
      const info = new UserUpdateInfo();
      if (this.$store.getters['user/userFirstName'] !== this.firstName) {
        info.setUserFirstName(this.firstName);
        info.setUserFirstNameWasUpdated(true);
      }
      if (this.$store.getters['user/userLastName'] !== this.lastName) {
        info.setUserLastName(this.lastName);
        info.setUserLastNameWasUpdated(true);
      }
      if (this.$store.getters['user/userNickname'] !== this.nickName) {
        info.setUserNickname(this.nickName);
        info.setUserNicknameWasUpdated(true);
      }
      if (this.$store.getters['user/userPhoneNumber'] !== this.phone) {
        info.setUserPhoneNumber(this.phone);
        info.setUserPhoneNumberWasUpdated(true);
      }
      request.setInfo(info);
      return request;
    },
    saveProfile() {
      return new Promise((resolve, reject) => {
        this.$refs.validationObserver.validate().then((isValid) => {
          if (!isValid) {
            reject(new Error('profile validation failed'));
            return;
          }
          console.info('updating profile...');
          const request = this.buildUpdateRequest();
          this.$store.dispatch('user/updateDetails', request).then((response) => {
            console.log('updated user profile', response.toObject());
            this.errorMessage = undefined; // set back to undefined in case there was a prior error
            return resolve(true);
          }).catch((error) => {
            console.log('promise rejected while updating user profile', error);
            this.errorMessage = error.message !== '' ? error.message : 'Whoops... Something went wrong.';
            reject(this.errorMessage);
          });
        });
      });
    },
    profilePicEvent(input) {
      // this fires after a user selects an input image
      if (input) this.profileImageSrc = input;
    },
    cropFinish(croppedImage) {
      // this fires after a user finishes cropping
      console.log('CROP FINISHED', croppedImage);
      this.profileImageCropped = croppedImage;
    },

  },
};
</script>

<style scoped>
.cropper-crop-box, .cropper-view-box {
  border-radius: 50%;
}

.cropper-view-box {
  box-shadow: 0 0 0 1px #39f;
  outline: 0;
}

.cropper-face {
  background-color:inherit !important;
}

.cropper-dashed, .cropper-point.point-se, .cropper-point.point-sw, .cropper-point.point-nw,   .cropper-point.point-ne, .cropper-line {
  display:none !important;
}

.cropper-view-box {
  outline:inherit !important;
}
</style>
